import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=1dc42ffc&scoped=true"
import script from "./addLabel.vue?vue&type=script&lang=js"
export * from "./addLabel.vue?vue&type=script&lang=js"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=1dc42ffc&prod&scoped=true&lang=css"
import style1 from "./addLabel.vue?vue&type=style&index=1&id=1dc42ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc42ffc",
  null
  
)

export default component.exports